import React from 'react'
import {ReactComponent as Under} from "../../assets/Under-construction.svg"
function UnderConstruction() {
    return (
      <>
        <div style={{position: "relative" ,
    top: "-55px"}} >
          <Under />
        </div>
      </>
    );
}

export default UnderConstruction
